import React, { useEffect, useState } from 'react';
import { Modal, Select } from 'antd';
//import { useAppDispatch } from '../../../app/hooks';
//import { listArtwork, selectAllArtworks } from '../store/artwork.slice';
//import { useSelector } from 'react-redux';
import { Artwork } from '../models/artwork';

type ArtworkSearchModalProps = {
  availableArtworks: Artwork[];
  onSubmit: (artwork: Artwork) => void;
  onCancel: () => void;
  visible: boolean;
};

export const ArtworkSearchModal: React.FC<ArtworkSearchModalProps> = ({
  availableArtworks,
  onSubmit,
  onCancel,
  visible,
}) => {
  //const dispatch = useAppDispatch();
  //const artworks = useSelector(selectAllArtworks);
  const [artworkId, setArtworkId] = useState();

  /**useEffect(() => {
    dispatch(listArtwork());
  }, [dispatch]);**/

  const handleSubmit = () => {
    onSubmit(availableArtworks.find(artwork => artwork._id === artworkId)!);
  }

  return (
    <Modal
      open={visible}
      title={"Search artwork"}
      onCancel={onCancel}
      onOk={handleSubmit}
    >
      <Select
        showSearch
        optionFilterProp="children"
        value={artworkId}
        onChange={setArtworkId}
        style={{ width: "100%" }}
      >
        {availableArtworks.map(aw => (<Select.Option key={aw._id} value={aw._id}>{aw.name + ", " + aw.year}</Select.Option>))}
{/*         {artworks.map(artwork => (
          <Select.Option key={artwork._id} value={artwork._id}>{artwork.name}</Select.Option>
        ))} */}
      </Select>
    </Modal>
  );
};
